export const succes = 'success';
export const success = 'success'; // Alias pour consistency
export const danger = 'danger';
export const primary = 'primary';
export const secondary = 'secondary';
export const actualiser = 'refresh';
export const fermer = 'fermer';
export const outil = 'outil';
export const fermeCi = 'fermeCi';
export const Wait = 'Wait';
export const popupferme = 'popupferme';
export const Max = 'Max';
export const Min = 'Min';
export const succeSimple = 'succeSimple';
export const lupeSearch = 'lupeSearch';
export const lupeSearchClose = 'lupeSearchClose';
export const btnDisable = 'btnDisable';
export const refresh = 'refresh';
